import { render, staticRenderFns } from "./BenestareInsit.vue?vue&type=template&id=448d388f&scoped=true&"
import script from "./BenestareInsit.vue?vue&type=script&lang=js&"
export * from "./BenestareInsit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448d388f",
  null
  
)

export default component.exports